import api from '../axios'


export default {
  login: (payload) => api.post('/login', payload),
  logout: () => api.put('/logout'),
  getCurrentUser: () => api.get('/get-current'),
  getPermissions: () => api.get('/get-current-permissions'),
  verify2FA: (payload, staff_id) => api.put(`/2fa/${staff_id}/validate-2fa`, payload),
}
